require('./outdatedbrowser.min.css');
var outdatedBrowser = require('exports-loader?outdatedBrowser!./outdatedbrowser.min.js');
var lang = [];
lang['en'] = require('./lang/en.html');
lang['fr'] = require('./lang/fr.html');
lang['pt'] = require('./lang/pt.html');
lang['de'] = require('./lang/de.html');
lang['es'] = require('./lang/es.html');
lang['it'] = require('./lang/it.html');
lang['nl'] = require('./lang/nl.html');
//event listener: DOM ready
function addLoadEvent(func) {
    var oldonload = window.onload;
    if (typeof window.onload != 'function') {
        window.onload = func;
    } else {
        window.onload = function() {
            if (oldonload) {
                oldonload();
            }
            func();
        }
    }
}
//call plugin function after DOM ready
addLoadEvent(function(){
    var userLang = navigator.language || navigator.userLanguage || 'en';
    userLang = userLang.slice(2);
    var languages = /en|fr|pt|de|es|it|nl/;
    userLang = userLang.match(languages) ? userLang : 'en';
    var outdated = document.getElementById("outdated");
    outdated.innerHTML = lang[userLang];
    outdatedBrowser({
        bgColor: '#f25648',
        color: '#ffffff',
        lowerThan: 'IE10',
        languagePath: ''
    })
});




//////////////////
// WEBPACK FOOTER
// ./outdated-browser/browser.js
// module id = 816
// module chunks = 2